export { default } from './ShelfUtilityBar';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfUtilityBar/index.js